var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.calcNameSvg(),_vm._b({tag:"component",attrs:{"kcpGroupId":_vm.kcpGroupId,"regionId":_vm.regionId}},'component',_vm.values,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }